/**
 * Sparklayer Test Script
 * Simple test script to help debug the carousel sync
 */

// Test function to check all components
function testAll() {
    console.log('🧪 Testing all components...');
    
    // Test B2B detection
    console.log('\n1. B2B Customer Detection:');
    console.log('  - window.customer:', window.customer);
    console.log('  - customer.tags:', window.customer?.tags);
    console.log('  - debug_b2b in URL:', window.location.search.includes('debug_b2b=true'));
    console.log('  - Sparklayer widget present:', !!document.querySelector('spark-pdp'));
    
    // Test carousel detection
    console.log('\n2. Carousel Detection:');
    const carouselSelectors = [
        '.js-product-media-slider',
        '.product-media__slider',
        '.swiper',
        '.product-gallery',
        '[data-swiper]'
    ];
    
    carouselSelectors.forEach(selector => {
        const element = document.querySelector(selector);
        console.log(`  - ${selector}:`, !!element, element ? `(swiper: ${!!element.swiper})` : '');
    });
    
    // Test Sparklayer widget
    console.log('\n3. Sparklayer Widget:');
    const sparkWidget = document.querySelector('spark-pdp');
    console.log('  - Widget found:', !!sparkWidget);
    
    if (sparkWidget && sparkWidget.shadowRoot) {
        const shadowRoot = sparkWidget.shadowRoot;
        console.log('  - Shadow root:', !!shadowRoot);
        
        const table = shadowRoot.querySelector('table');
        console.log('  - Table found:', !!table);
        
        const rows = shadowRoot.querySelectorAll('tr');
        console.log('  - Rows found:', rows.length);
        
        if (rows.length > 0) {
            console.log('  - First row HTML:', rows[0].outerHTML.substring(0, 200) + '...');
        }
    }
    
    // Test manual sync
    console.log('\n4. Manual Sync Test:');
    if (window.manualSync) {
        console.log('  - manualSync function available: true');
        console.log('  - Running manual sync...');
        window.manualSync();
    } else {
        console.log('  - manualSync function not available');
    }
    
    return {
        b2b: window.location.search.includes('debug_b2b=true') || !!document.querySelector('spark-pdp'),
        carousel: !!document.querySelector('.js-product-media-slider'),
        sparklayer: !!sparkWidget,
        rows: sparkWidget && sparkWidget.shadowRoot ? sparkWidget.shadowRoot.querySelectorAll('tr').length : 0
    };
}

// Make test function globally available
window.testAll = testAll;

// Auto-run test after a delay
setTimeout(() => {
    console.log('🔍 Auto-running test after 3 seconds...');
    testAll();
}, 3000);

console.log('✅ Sparklayer test script loaded. Run testAll() to test all components.');
